import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import zhHans from 'vuetify/lib/locale/zh-Hans'

Vue.use(Vuetify);

export default new Vuetify({
    theme: { dark: false },
    lang: {
        locales: { zhHans },
        current: 'zhHans',
    },
    icons: {
        iconfont: 'md',
    },
});
